export const COMPLETE = "complète";
export const COMPACT = "compacte";
